import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { CalculationState } from '../reducers';

export const selectCalculationModuleState = createFeatureSelector<CalculationState>(MODULE_KEY);
